import React from 'react';
import { ShieldCheck, Cpu, Layers, Sparkles, BookOpen, Lock, Terminal, FileSpreadsheet } from 'lucide-react';

export const FeatureGrid: React.FC = () => {
  const features = [
    {
      title: 'Fact-Check & RAG Contínuo',
      desc: 'Blindagem ativa contra alucinações. O motor cruza dados e fatos para garantir que afirmações técnicas possuam embasamento verificável.',
      icon: ShieldCheck
    },
    {
      title: 'Humanizer Engine',
      desc: 'Remoção cirúrgica de maneirismos robóticos, frases de abertura clichês e ritmo monótono, entregando prosa fluida e de tom autoral.',
      icon: Sparkles
    },
    {
      title: 'Compilador Físico Determinístico',
      desc: 'Geração real de arquivos binários: contagem exata de páginas, sumários com linkagem precisa, fontes legíveis e zero páginas em branco.',
      icon: Cpu
    },
    {
      title: 'DNA de Marca & Consistência',
      desc: 'Todas as saídas (ebook, workbook, VSL, página e e-mails) utilizam o mesmo vocabulário e a mesma promessa central do início ao fim.',
      icon: Layers
    },
    {
      title: 'Arquitetura Editorial Guiada',
      desc: 'Estruturação curricular pedagógica para que o aluno aprenda em progressão lógica, de conceitos fundamentais aos avançados.',
      icon: BookOpen
    },
    {
      title: 'Isolamento de Dados & Segurança',
      desc: 'Suas ideias, teses e estratégias comerciais permanecem privadas. Seus produtos não são utilizados para treinar modelos abertos.',
      icon: Lock
    },
    {
      title: 'Biblioteca de Prompts Práticos',
      desc: 'Geração automática de comandos e exercícios prontos para os alunos do seu infoproduto copiarem e aplicarem imediatamente.',
      icon: Terminal
    },
    {
      title: 'Workbooks e Folhas de Aplicação',
      desc: 'Cadernos de exercícios práticos que acompanham cada capítulo do ebook, elevando a percepção de valor e o engajamento do aluno.',
      icon: FileSpreadsheet
    }
  ];

  return (
    <section className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-semibold uppercase tracking-wider text-brand-cyan px-3 py-1 rounded-full bg-brand-cyan/10 border border-brand-cyan/20">
            Recursos da Plataforma
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-4 mb-5 tracking-tight">
            Engenharia Robusta em Cada Camada
          </h2>
          <p className="text-base sm:text-lg text-brand-textMuted leading-relaxed">
            Desenvolvido para criadores, especialistas e agências que não aceitam infoprodutos amadores ou rasos.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, index) => {
            const Icon = feat.icon;
            return (
              <div
                key={index}
                className="p-6 rounded-2xl bg-brand-surface border border-brand-border hover:border-brand-primary/40 transition-all duration-300 group flex flex-col justify-between"
              >
                <div>
                  <div className="w-10 h-10 rounded-xl bg-brand-bg border border-brand-border/60 flex items-center justify-center text-brand-primary mb-4 group-hover:scale-105 group-hover:text-brand-cyan transition-all">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="text-base font-bold text-white mb-2 group-hover:text-brand-cyan transition-colors">
                    {feat.title}
                  </h3>
                  <p className="text-xs text-brand-textMuted leading-relaxed">
                    {feat.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
